import Marquee from "react-fast-marquee";

const WORDS = [
  "Orthopedic",
  "Memory Foam",
  "HR Foam",
  "Pocket Spring",
  "Sofa Foam",
  "Made in Delhi",
];

export const EditorialMarquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-border bg-[#FFFFFF] py-10 md:py-14"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading marquee-italic font-light text-5xl md:text-7xl text-foreground px-8">
              {w}
            </span>
            <span className="text-accent text-3xl md:text-5xl">✳</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
